import { cloneElement } from "react";

// It must be better if we keep className prop from `children`
// it can be done using: `classnames(children.props.className, "modal__control")`
export const ModalControl = ({ children }) => {
  return cloneElement(children, {
    className: "modal__control",
  });
};
